import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@lsq/nextgen/v2/button';
import TeamsViewMenuCard from '../../shared/components/TeamsViewMenuCard/index';
import { ROUTES_PATH } from '../../../../constants/globalConstant';
import analytics from '../../../../utils/analytics';
import { ReactComponent as Add } from '../../../../assets/svgIcons/lsq_add.svg';

export const MenuCell = ({ data, menuById }) => {
  const navigate = useNavigate();
  const menuId = data.menu;

  const teamsViewMenuCardClicked = (menuId) => {
    navigate(`${ROUTES_PATH.menubuilder}/${menuId}`);
    analytics.sendEvent(`clicked Teams view menu card`, {
      category: 'update_menu',
      menuId: menuId
    });
  };

  const addMenuCardClicked = () => {
    navigate(ROUTES_PATH.menubuilder);
    const analytics_data = {
      category: 'create_menu',
      type: 'click'
    };
    analytics.sendEvent(`create menu from Teams view add menu card`, analytics_data);
  };

  return menuId ? (
    <TeamsViewMenuCard
      menu={menuById[menuId]}
      cardClickHandler={() => teamsViewMenuCardClicked(menuId)}
    />
  ) : (
    <Button
      size="xs"
      variant="secondary-gray"
      icon={<Add />}
      onClick={addMenuCardClicked}
      data-testid="add-menu-button"
      text="Add Menu"
    />
  );
};
